/**
 * THE ONE WAY TO ASK "IS THIS KEY THE OBJECT'S OWN?" on app.* and book.*.
 *
 * `Object.hasOwn` is ES2022, and Safari only has it from 15.4: on iOS 15.0 to
 * 15.3 it is not a function, and calling it threw inside RecaptchaNotice, which
 * renders on every Book page and on App /login, so those pages fell into the
 * error boundary (Prod rc.5, Sentry LURA-BOOK-WEB-7, 2026-10-13). The build
 * targets es2022 with no runtime polyfills, so nothing rewrote the call.
 *
 * `Object.prototype.hasOwnProperty.call` answers the same question in every
 * browser, and keeps what callers rely on it for: an inherited name
 * ("__proto__", "constructor", "toString") is NOT the object's own, so a
 * lookup table never hands back something from the prototype. It is also
 * immune to an object that shadows `hasOwnProperty` or has no prototype.
 *
 * `npm run quality:contracts` refuses `Object.hasOwn` anywhere in source (the
 * runtime-baseline contract).
 */
export function hasOwn(object: object, key: PropertyKey): boolean {
  return Object.prototype.hasOwnProperty.call(object, key);
}
